import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Response } from '../../../../shared/models/response.model';
import { Livrable } from '../models/livrable.model';
import { LivrableCreateRequest } from '../requests/livrable-create-request';
import { LivrableUpdateRequest } from '../requests/livrvable-update-request';

@Injectable({
  providedIn: 'root',
})
export class LivrableService {
  #http = inject(HttpClient);

  readonly BASE_URL = `/livrables`;

  findAll(idReferentiel: string) {
    return this.#http.get<Response<Livrable>>(this.BASE_URL, { params: { idReferentiel } });
  }

  findById(idLivrable: string): Observable<Livrable> {
    return this.#http.get<Livrable>(this.BASE_URL + '/' + idLivrable);
  }

  créer(data: LivrableCreateRequest) {
    return this.#http.post<Livrable>(this.BASE_URL, data);
  }

  modifier(idLivrable: string, data: LivrableUpdateRequest) {
    return this.#http.put<{ path: string }>(this.BASE_URL + '/' + idLivrable, data);
  }

  supprimer(idLivrable: string) {
    return this.#http.delete<void>(this.BASE_URL + '/' + idLivrable);
  }
}
